var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "report",
      rawName: "v-report",
      value: _vm.reportData.固定入口按钮(_vm.data.sTitle),
      expression: "reportData.固定入口按钮(data.sTitle)"
    }],
    staticClass: "nav_box",
    on: {
      "click": _vm.jump
    }
  }, [_c('v-image', {
    staticClass: "icon",
    attrs: {
      "src": _vm._f("pic")(_vm.data, '100x100'),
      "alt": "",
      "placeholder-type": "color",
      "simple-mode": !_vm.isInApp,
      "placeholder-color": 'rgba(0,0,0,0)'
    }
  }), _c('span', {
    staticClass: "txt",
    attrs: {
      "AEGIS-FIRST-SCREEN-TIMING": ""
    }
  }, [_vm._v(_vm._s(_vm.data.sTitle))]), _vm.redPointShow && _vm.hasRedPoint && _vm.isMounted ? _c('span', {
    staticClass: "wel"
  }, [_vm._v(_vm._s(_vm.redPointMsg))]) : _vm._e(), _vm.isVipInvitation ? _c('span', {
    staticClass: "wel"
  }, [_vm._v(_vm._s(_vm.invitationMsg))]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };